import { Link } from "react-router-dom";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { OCCASIONS } from "@/config/site";

const Occasions = () => (
    <section className="py-24 sm:py-36" data-testid="occasion-shopping">
        <div className="max-w-[1500px] mx-auto px-5 sm:px-8">
            <SectionHeading
                eyebrow="Shop by Occasion"
                title={<>Find Jewellery for <span className="italic gold-text">Every Moment</span></>}
            />
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {OCCASIONS.map((o, i) => (
                    <Reveal key={o.name} delay={(i % 3) * 0.08}>
                        <Link
                            to={o.to}
                            data-testid={`occasion-card-${o.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="group relative block overflow-hidden border border-gold/10 hover:border-gold/50 transition-colors duration-500"
                        >
                            <div className="aspect-[4/5] sm:aspect-[4/4] overflow-hidden">
                                <img
                                    src={o.image}
                                    alt={`${o.name} jewellery at BSK Jewellers Amritsar`}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-[1000ms] group-hover:scale-[1.07]"
                                />
                            </div>
                            <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/45 to-obsidian/10" />
                            <div className="absolute bottom-0 inset-x-0 p-5 sm:p-7">
                                <h3 className="font-serif text-xl sm:text-2xl text-ivory group-hover:text-gold transition-colors duration-500">{o.name}</h3>
                                <p className="text-[11px] sm:text-xs text-sand mt-1 italic font-serif">{o.line}</p>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Occasions;
